import { render } from "./SSpinner.vue?vue&type=template&id=e54aed4e&scoped=true&ts=true"
import script from "./SSpinner.ts?vue&type=script&lang=ts"
export * from "./SSpinner.ts?vue&type=script&lang=ts"

import "./SSpinner.scss?vue&type=style&index=0&id=e54aed4e&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e54aed4e"]])

export default __exports__